/* ============================================================================
   pers-cpc-overlay.js — nakładka UI nad żywym kalkulatorem CPC.

   DLACZEGO ASSET MOTYWU, A NIE POLE "Custom JS" W PANELU CPC:

   1. Wyłącznik globalny jest ustawieniem sekcji — a ustawienia sekcji istnieją
      tylko w motywie. Panel nie ma jak ich odczytać.
   2. Kalkulator 620d2b5edfd38 jest WSPÓŁDZIELONY przez dwa żywe produkty.
      Kod w panelu trafiłby na oba; nakładka jest projektowana pod ten jeden
      szablon i nie ma prawa wyciec na produkt „na sztuki".
   3. Panel udowodnił wrogość: odrzuca komentarze, znaki spoza ASCII
      i cudzysłowy błędem 500, a długą treść tnie po cichu. Ten plik jest
      kilka razy większy od kosmetycznego script.js i pełen polskich etykiet.
   4. Asset motywu jest wersjonowany i objęty weryfikacją wgrywania.

   W panelu zostaje wyłącznie kosmetyka (przecinek w cenie, cena jednostkowa,
   komunikaty) — bo ta ma działać na OBU produktach, niezależnie od szablonu.

   ── CZERWONE LINIE ────────────────────────────────────────────────────────
   ZAPISUJEMY wyłącznie do pól konfiguracyjnych: wymiary, nakład, wykrojnik,
   uszlachetnienie. Wyłącznie z akcji użytkownika. Wyłącznie wartościami
   mieszczącymi się w zakresach zadeklarowanych przez samo CPC (atrybuty
   min/max pól). Wartość spoza zakresu jest ODRZUCANA, nie przycinana po cichu.

   NIGDY: cena, #cpcPriceToken, #variantIdCustom, wysyłka formularza, walidacja,
   pole uploadu. Nie wołamy PriceUpdation ani ChangeEvent bezpośrednio —
   wysyłamy natywne zdarzenie, a inline handlery aplikacji łapią je same.
   Cena jest liczona wyłącznie formułą CPC.

   Awaria = strona bez nakładki, nie strona zepsuta: klasa `pcv-on` na
   kalkulatorze jest dokładana przez ten skrypt PO udanej budowie. Cały CSS
   nakładki wisi na tej klasie, więc błąd JS zostawia czyste, widoczne pola CPC.
   ============================================================================ */

(function () {
  'use strict';

  var KONF = document.getElementById('pcv-konfiguracja');
  if (!KONF || KONF.dataset.wlaczona !== 'true') return;

  /* ---------------------------------------------------------------- montaz

     Kalkulator CPC jest WSTRZYKIWANY PO STRONIE KLIENTA — w HTML serwerowym
     go nie ma. Skrypt z defer startuje, zanim aplikacja zbuduje #calculator,
     wiec siegniecie po niego od razu zwraca null i nakladka wychodzi po cichu.
     Tak wlasnie wygladala pierwsza wersja: czyste pola CPC, zero przyciskow,
     zero bledow w konsoli. Kosmetyczny script.js mial tu obserwatora od poczatku;
     nakladka go nie odziedziczyla.

     Czekamy nie na sam #calculator, tylko na jego POLA: aplikacja potrafi
     wstawic pusty kontener i dopiero potem go wypelnic, a nakladka zbudowana
     na polowie kalkulatora bylaby gorsza niz jej brak.
     -------------------------------------------------------------------------- */

  var WYMAGANE_POLA = 3; // dwa wymiary + naklad; mniej znaczy, ze appka jeszcze buduje

  function gotowyKalkulator() {
    var k = document.getElementById('calculator');
    if (!k) return null;
    var pola = k.querySelectorAll('.element[data-element] input, .element[data-element] select');
    return pola.length >= WYMAGANE_POLA ? k : null;
  }

  function czekajNaKalkulator(gotowe) {
    var k = gotowyKalkulator();
    if (k) { gotowe(k); return; }

    var obs = new MutationObserver(function () {
      var k2 = gotowyKalkulator();
      if (!k2) return;
      obs.disconnect();
      clearTimeout(limit);
      gotowe(k2);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Limit czasu, zeby obserwator nie wisial na stronach bez kalkulatora.
    var limit = setTimeout(function () { obs.disconnect(); }, 15000);
  }

  czekajNaKalkulator(zbuduj);

  function zbuduj(kalkulator) {
    // Obserwator moze wystrzelic przy kolejnej przebudowie DOM przez appke.
    if (kalkulator.classList.contains('pcv-on')) return;

  /* ---------------------------------------------------------------- pomocnicze */

  function pole(wzorzec) {
    var boxy = kalkulator.querySelectorAll('.element[data-element]');
    for (var i = 0; i < boxy.length; i++) {
      if (wzorzec.test(boxy[i].getAttribute('data-element') || '')) return boxy[i];
    }
    return null;
  }

  function el(tag, klasa, tekst) {
    var e = document.createElement(tag);
    if (klasa) e.className = klasa;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  function etykietaPola(box) {
    var l = box.querySelector('label');
    return l ? l.textContent.trim() : '';
  }

  // Zapis do pola liczbowego. Zakres bierzemy z atrybutow SAMEGO CPC, nie
  // z wlasnej listy — jesli Wiktor zmieni limity w panelu, nakladka pojdzie za nimi.
  function ustawLiczbe(input, wartosc) {
    if (!input || !isFinite(wartosc)) return false;
    var min = parseFloat(input.getAttribute('min'));
    var max = parseFloat(input.getAttribute('max'));
    // Odrzucamy zamiast przycinac: ciche przyciecie dawaloby uzytkownikowi
    // inna wartosc niz ta, ktora kliknal, bez slowa wyjasnienia.
    if (isFinite(min) && wartosc < min) return false;
    if (isFinite(max) && wartosc > max) return false;

    input.value = String(wartosc);
    // Pola CPC maja onkeyup ORAZ onchange na PriceUpdation. Natywny 'change'
    // uruchamia inline handler tak samo jak zmiana z klawiatury.
    przelicz(input);
    return true;
  }

  // Wyzwolenie przeliczenia — dwa razy, w odstepie.
  //
  // Raz zaobserwowano, ze klikniecie kafla tuz po innej zmianie dalo cene
  // niezgodna z formula, a powtorzenie akcji juz nie. Wyglada na wyscig:
  // przeliczenie appki bylo w locie, gdy przyszla nasza zmiana, i jego wynik
  // nadpisal nowszy. Ponowienie zdarzenia po chwili wymusza przeliczenie
  // od aktualnego stanu pol.
  //
  // Kosztuje jedno dodatkowe wywolanie funkcji, ktora appka i tak wola przy
  // kazdym nacisnieciu klawisza, a wynik jest idempotentny — wartosc pola
  // sie nie zmienia, wiec drugie przeliczenie daje to samo co pierwsze.
  function przelicz(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () {
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }, 150);
  }

  // Zapis do selecta przez selectedIndex, nie przez .value: opcje CPC nie maja
  // atrybutu value (tylko data-val i data-label), wiec .value zalezy od tresci
  // tekstowej i bialych znakow. Indeks jest odporny na jedno i drugie.
  function ustawWybor(select, indeks) {
    if (!select || indeks < 0 || indeks >= select.options.length) return false;
    select.selectedIndex = indeks;
    przelicz(select);
    return true;
  }

  function liczbaZPola(input) {
    var v = parseFloat(String(input && input.value).replace(',', '.'));
    return isFinite(v) ? v : NaN;
  }

  /* ---------------------------------------------------------------- pola CPC */

  var boxWys = pole(/wysok/i);
  var boxSzer = pole(/szerok/i);
  var boxNakl = pole(/nak\w?ad/i);
  var boxKszt = pole(/wykrojnik/i);
  var boxUszl = pole(/uszlachetn/i);

  // Bez wymiarow nakladka nie ma sensu — wychodzimy, zostawiajac czyste CPC.
  if (!boxWys || !boxSzer) return;

  var inpWys = boxWys.querySelector('input');
  var inpSzer = boxSzer.querySelector('input');
  var inpNakl = boxNakl ? boxNakl.querySelector('input') : null;
  var selKszt = boxKszt ? boxKszt.querySelector('select') : null;
  var selUszl = boxUszl ? boxUszl.querySelector('select') : null;
  if (!inpWys || !inpSzer) return;

  var doOdswiezenia = [];

  /* ---------------------------------------------------------------- 1. wymiary */

  function parsujWymiary(tekst) {
    var lista = [];
    String(tekst || '').split(',').forEach(function (kawalek) {
      var m = kawalek.trim().match(/^(\d+)\s*[x×]\s*(\d+)$/i);
      if (!m) return;
      lista.push({ szer: parseInt(m[1], 10), wys: parseInt(m[2], 10) });
    });
    return lista;
  }

  function wZakresie(input, wartosc) {
    var min = parseFloat(input.getAttribute('min'));
    var max = parseFloat(input.getAttribute('max'));
    if (isFinite(min) && wartosc < min) return false;
    if (isFinite(max) && wartosc > max) return false;
    return true;
  }

  var krokWymiar = el('div', 'pcv-krok');
  var naglowekWymiar = el('div', 'pcv-krok__head');
  naglowekWymiar.appendChild(el('span', 'pcv-krok__nr', '1. Wymiar naklejki'));
  krokWymiar.appendChild(naglowekWymiar);

  // Rzad "szerokosc x wysokosc". Przenosimy CALE kontenery .element — wezly
  // aplikacji zostaja nietkniete w srodku, zmienia sie tylko ich miejsce
  // w drzewie. Kolejnosc jak w projekcie: szerokosc, znak, wysokosc.
  var rzad = el('div', 'pcv-rzad');
  rzad.appendChild(boxSzer);
  rzad.appendChild(el('span', 'pcv-rzad__znak', '×'));
  rzad.appendChild(boxWys);
  krokWymiar.appendChild(rzad);

  var chipy = parsujWymiary(KONF.dataset.wymiary);
  if (chipy.length) {
    var pasChipow = el('div', 'pcv-chipy');
    pasChipow.appendChild(el('span', 'pcv-chipy__label', 'Popularne:'));
    var przyciskiChipow = [];

    chipy.forEach(function (wym) {
      // Chip poza zakresem CPC w ogole sie nie pojawia — uzytkownik nie moze
      // kliknac czegos, czego kalkulator i tak by nie przyjal.
      if (!wZakresie(inpSzer, wym.szer) || !wZakresie(inpWys, wym.wys)) return;

      var b = el('button', 'pcv-chip', wym.szer + '×' + wym.wys);
      b.type = 'button';
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        ustawLiczbe(inpSzer, wym.szer);
        ustawLiczbe(inpWys, wym.wys);
        odswiez();
      });
      przyciskiChipow.push({ btn: b, wym: wym });
      pasChipow.appendChild(b);
    });

    if (przyciskiChipow.length) {
      krokWymiar.appendChild(pasChipow);
      doOdswiezenia.push(function () {
        var s = liczbaZPola(inpSzer), w = liczbaZPola(inpWys);
        przyciskiChipow.forEach(function (p) {
          var aktywny = p.wym.szer === s && p.wym.wys === w;
          p.btn.classList.toggle('pcv--aktywny', aktywny);
          p.btn.setAttribute('aria-pressed', aktywny ? 'true' : 'false');
        });
      });
    }
  }

  /* ------------------------------------------------- 2 i 4. wybory z selectow */

  // Buduje rzad przyciskow z REALNYCH opcji selecta. Nazwy sa enumerowane
  // z DOM — nigdy zgadywane, bo lista opcji jest w gestii panelu aplikacji.
  function grupaZSelecta(select, box, numer) {
    if (!select || !select.options.length) return null;

    var krok = el('div', 'pcv-krok');
    var head = el('div', 'pcv-krok__head');
    head.appendChild(el('span', 'pcv-krok__nr', numer));
    krok.appendChild(head);

    var grupa = el('div', 'pcv-grupa');
    grupa.setAttribute('role', 'group');
    grupa.setAttribute('aria-label', etykietaPola(box) || numer);

    var przyciski = [];
    for (var i = 0; i < select.options.length; i++) {
      (function (indeks) {
        var opcja = select.options[indeks];
        var napis = (opcja.getAttribute('data-label') || opcja.textContent || '').trim();
        var b = el('button', 'pcv-btn', napis);
        b.type = 'button';
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          ustawWybor(select, indeks);
          odswiez();
        });
        przyciski.push(b);
        grupa.appendChild(b);
      })(i);
    }
    krok.appendChild(grupa);

    doOdswiezenia.push(function () {
      przyciski.forEach(function (b, i) {
        var aktywny = select.selectedIndex === i;
        b.classList.toggle('pcv--aktywny', aktywny);
        b.setAttribute('aria-pressed', aktywny ? 'true' : 'false');
      });
    });

    // Natywna kontrolka zostaje w DOM i pozostaje ostylowana przez CPC —
    // chowamy ja technika przycinania, a NIE display:none. Element ukryty
    // przez display jest w Chrome niefokusowalny, a wtedy walidacja formularza
    // potrafi zablokowac wysylke komunikatem o niefokusowalnym polu.
    box.classList.add('pcv-schowany');
    select.setAttribute('tabindex', '-1');

    return krok;
  }

  /* ---------------------------------------------------------------- 3. naklad */

  // Rabaty na kaflach. Wartosci pochodza z METAPOLA PRODUKTU `custom.rabaty_nakladu`,
  // nie z kodu i nie z ustawienia szablonu: zrodlem prawdy jest formula CPC
  // (Value Range pola Naklad), a kazdy produkt ma wlasny kalkulator. Jedna
  // wartosc na szablon klamalaby wszedzie poza jednym produktem.
  // Puste metapole = pusta mapa = zadnych badge. Tak ma byc.
  function mapaRabatow() {
    var mapa = {};
    String(KONF.dataset.rabaty || '').split(',').forEach(function (para) {
      var cz = para.split(':');
      if (cz.length !== 2) return;
      var ile = parseInt(cz[0].trim(), 10);
      var txt = cz[1].trim();
      if (!isFinite(ile) || !txt) return;
      // Metapole trzyma sama liczbe ("-20"); procent dokladamy przy renderze,
      // zeby format metapola byl jednoznaczny do maszynowego zapisu.
      mapa[ile] = /^-?\d+$/.test(txt) ? txt + '%' : txt;
    });
    return mapa;
  }

  function krokNakladu() {
    if (!inpNakl) return null;

    var krok = el('div', 'pcv-krok');
    var head = el('div', 'pcv-krok__head');
    head.appendChild(el('span', 'pcv-krok__nr', '3. Nakład (szt.)'));
    krok.appendChild(head);

    var rabaty = mapaRabatow();
    var kafle = [];
    var siatka = el('div', 'pcv-kafle');
    String(KONF.dataset.naklady || '').split(',').forEach(function (kawalek) {
      var n = parseInt(kawalek.trim(), 10);
      if (!isFinite(n)) return;
      // Kafel ponizej minimum CPC (dzis 100 szt) nie ma prawa istniec.
      if (!wZakresie(inpNakl, n)) return;

      var b = el('button', 'pcv-kafel');
      b.type = 'button';
      b.appendChild(el('span', 'pcv-kafel__n', String(n)));
      // Badge tylko tam, gdzie rabat zdefiniowano. Naklad wpisany recznie
      // w pole „inny naklad" nie dostaje adnotacji — nie znamy jego progu.
      if (rabaty[n]) b.appendChild(el('span', 'pcv-kafel__rabat', rabaty[n]));
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        ustawLiczbe(inpNakl, n);
        odswiez();
      });
      kafle.push({ btn: b, n: n });
      siatka.appendChild(b);
    });

    if (!kafle.length) return null;
    krok.appendChild(siatka);

    doOdswiezenia.push(function () {
      var akt = liczbaZPola(inpNakl);
      kafle.forEach(function (k) {
        // Podswietlenie dziala tak samo, gdy uzytkownik WPISZE te wartosc recznie.
        var aktywny = k.n === akt;
        k.btn.classList.toggle('pcv--aktywny', aktywny);
        k.btn.setAttribute('aria-pressed', aktywny ? 'true' : 'false');
      });
    });

    // Pole "inny naklad" zostaje widoczne — to nie jest wybor z listy,
    // tylko wpis dowolnej liczby, wiec natywny input jest tu najlepszym UI.
    krok.appendChild(boxNakl);
    boxNakl.classList.add('pcv-inny');
    return krok;
  }

  /* ---------------------------------------------------------------- budowa */

  function odswiez() {
    for (var i = 0; i < doOdswiezenia.length; i++) doOdswiezenia[i]();
  }

  var krokKsztalt = grupaZSelecta(selKszt, boxKszt, '2. Kształt cięcia KissCut');
  var krokNakl = krokNakladu();
  var krokUszl = grupaZSelecta(selUszl, boxUszl, '4. Uszlachetnienie');

  // Wstawiamy w kolejnosci projektu, na miejscu pierwszego pola wymiaru.
  var kotwica = kalkulator.firstElementChild;
  var doWstawienia = [krokWymiar, krokKsztalt, krokNakl, krokUszl];
  for (var i = 0; i < doWstawienia.length; i++) {
    if (doWstawienia[i]) kalkulator.insertBefore(doWstawienia[i], kotwica);
  }

  // Sync w druga strone: reczna zmiana pola ma odswiezyc podswietlenia.
  [inpSzer, inpWys, inpNakl, selKszt, selUszl].forEach(function (k) {
    if (!k) return;
    k.addEventListener('input', odswiez);
    k.addEventListener('change', odswiez);
  });

  odswiez();

  // Klasa dokladana NA KONIEC: dopiero teraz CSS nakladki zaczyna dzialac.
  // Gdyby cokolwiek wyzej rzucilo wyjatkiem, uzytkownik dostaje czyste CPC.
  kalkulator.classList.add('pcv-on');

  } /* zbuduj */
})();
